import RevealOnScroll from './RevealOnScroll';

export default function Barbers({ barbers, onBooking }) {
  return (
    <section className="section" id="barbers">
      <RevealOnScroll>
        <div className="section-header">
          <span className="section-tag">Ekibimiz</span>
          <h2 className="section-title">USTALARIMIZ</h2>
          <div className="section-ornament">
            <div className="line" />
            <div className="dot" />
            <div className="line" />
          </div>
        </div>
      </RevealOnScroll>
      <div className="barbers-wrap">
        {barbers.map((b, i) => (
          <RevealOnScroll key={b.id}>
            <div className="barber-card">
              <div className="barber-img-wrap">
                <span className="barber-number">NO. {String(i + 1).padStart(2, '0')}</span>
                <span className="barber-vip">VIP Master</span>
                <div className="corner tl" />
                <div className="corner tr" />
                <div className="corner bl" />
                <div className="corner br" />
                {b.photo_url ? (
                  <img src={b.photo_url} alt={b.name} className="barber-img" />
                ) : (
                  <div className="barber-placeholder">
                    <span className="initial">{b.initial}</span>
                  </div>
                )}
              </div>
              <div className="barber-info">
                <h3 className="barber-name">{b.name.toUpperCase()}</h3>
                <p className="barber-role">{b.title}</p>
                <button className="barber-btn" onClick={() => onBooking(b.id)}>
                  Randevu Al <span className="arrow">&rarr;</span>
                </button>
              </div>
            </div>
          </RevealOnScroll>
        ))}
      </div>
    </section>
  );
}
